<template>
  <main>
    <section class="bg-white dark:bg-staticsecondary-900 ">
    <div class="container flex items-center justify-center min-h-screen w-full px-6 py-12">
        <div>
            <base-logo :filename="logo" alt="EdasNEO" class="mb-6"/>
            <p class="text-sm font-medium text-staticprimary-800 dark:text-staticprimary-400">Error 404</p>
            <h1 class="mt-3 text-2xl font-semibold text-staticsecondary dark:text-white md:text-3xl">Página no encontrada</h1>
            <p class="mt-4 text-staticsecondary-600 dark:text-staticsecondary-400">Lo sentimos, la página que estás buscando no existe o se encuentra en otra dirección.</p>

            <div class="flex items-center mt-6 gap-x-3">
              <base-button 
              mode="staticsecondary"
              text="Volver" 
              @click="goBack()"
              />
              
              <router-link :to="{ name: 'dashboard' }">
                  <base-button 
                mode="staticprimary"
                text="Página principal" 
                />
              </router-link>
            </div>
        </div>
    </div>
    </section>
  </main>
</template>

<script>
export default {
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    logo: function () {
      if (this.darkMode) {
        return 'edasneowhite.webp'
      }
      return 'edasneo.webp'
    },
  },
  methods: {
    goBack () {
      window.history.go(-1)
    }
  }
}
</script>

